import { useEffect } from "react"

import UserLocationHistoryForm from "./userLocationHistoryForm"



const UserLocationHistory = ({ open }) => {
    useEffect(() => {
        document.title = 'Upload Data Report'
    }, [])
    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            < UserLocationHistoryForm />
        </main>
    )
}
export default UserLocationHistory